import type { FC } from 'react';
import { useStore } from 'zustand';

import { Button } from '@motorway/mw-highway-code/src/components/Button';

import { ModalBackButton } from 'Features/SellerCommunications/components/ModalBackButton';
import { ModalBody } from 'Features/SellerCommunications/components/ModalBody';
import {
	EnquiriesSelectStore,
	markAsContactedService,
	modalService,
	ModalSteps,
} from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import {
	triggerSellerMessagingBackButtonClickedEvent,
	triggerSellerMessagingMarkAsContactedCancelButtonClickedEvent,
} from 'Services/analytics/events';
import { ModalStepsToStageMap } from 'Services/analytics/events/account/purchases/consts';

import styles from './MarkAsContactedConfirmation.module.scss';

export const MarkAsContactedConfirmation: FC = () => {
	const selectedSalesCount = useStore(EnquiriesSelectStore, ({ selectedSaleIds }) => selectedSaleIds.length);

	const onBackButtonClick = () => {
		modalService.onNavigate(ModalSteps.EnquirySelection);
		triggerSellerMessagingBackButtonClickedEvent({
			from: ModalStepsToStageMap.MarkAsContactedConfirmation,
			to: ModalStepsToStageMap.EnquirySelection,
		});
	};

	const onCancelButtonClick = () => {
		modalService.onNavigate(ModalSteps.EnquirySelection);
		triggerSellerMessagingMarkAsContactedCancelButtonClickedEvent();
	};

	return (
		<>
			<ModalBackButton onClick={onBackButtonClick} />
			<ModalBody>
				<div className={styles.fullHeightContainer}>
					<div className={styles.heading}>
						<h4 className={styles.title}>
							{T.translate(`markAsContacted.confirmation.title.${selectedSalesCount === 1 ? 'single' : 'multiple'}`, {
								count: selectedSalesCount,
							})}
						</h4>
						<p className={styles.description}>
							{T.translate(
								`markAsContacted.confirmation.description.${selectedSalesCount === 1 ? 'single' : 'multiple'}`,
								{ count: selectedSalesCount },
							)}
						</p>
					</div>
					<div className={styles.buttonContainer}>
						<Button
							label={T.translate('markAsContacted.confirmation.cancel')}
							onClick={onCancelButtonClick}
							variant="secondary"
						/>
						<Button
							label={T.translate('markAsContacted.confirmation.confirm', { count: selectedSalesCount })}
							onClick={markAsContactedService.onMarkAsContacted}
							variant="primary"
						/>
					</div>
				</div>
			</ModalBody>
		</>
	);
};
